/**
 * Select a random element from a given array
 */
export const selectAtRandom = (array) => {
    return array[Math.floor(Math.random() * array.length)];
};
